import { render, staticRenderFns } from "./ResultadosFunilCard.vue?vue&type=template&id=a811b4a4"
import script from "./ResultadosFunilCard.vue?vue&type=script&lang=ts"
export * from "./ResultadosFunilCard.vue?vue&type=script&lang=ts"
import style0 from "./ResultadosFunilCard.vue?vue&type=style&index=0&id=a811b4a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports